import React from 'react';

import { Route, Redirect } from 'react-router-dom';
import PropTypes from "prop-types";

// const [searchParams, setSearchParams] = useSearchParams();
const PrivateRoute = ({ component: Component, ...rest }) => {
  
    const data = localStorage.getItem("ckAdminUser") || "{}";
  const jsonData = JSON.parse(data) || {};
    return (
        <Route {...rest} render={props => {
            if (jsonData.jwttoken) { return <Component {...props} />; }
             return <Redirect to={{ pathname: '/login' }} />;
        }} />
    );
}

PrivateRoute.propTypes = {
    component: PropTypes.elementType
};

export default PrivateRoute;
